import { BlockConfig, OperationTypes, ContentTypes } from "../block-base";
import { BlockTypes } from "../block-types";

export const noSqlDbConfig: BlockConfig = {
  displayName: "No SQL DB",
  imagePath: "",
  isInitiator: true,
  isTerminator: false,
  isInterceptor: false,
  allowedInputTypes: new Set([
    BlockTypes.APP_SERVER,
    BlockTypes.AUTO_SCALING_GROUP,
    BlockTypes.CACHE,
    BlockTypes.LAMBDA,
    BlockTypes.NETWORK_LOAD_BALANCER,
    BlockTypes.PASSTHROUGH,
  ]),
  allowedOutputTypes: new Set(),
  inputCapacity: {
    total: 4875,
    byOperationType: {
      [`${OperationTypes.READ}`]: {
        total: 3375,
        byContentType: {
          [`${ContentTypes.DYNAMIC}`]: 250,
          [`${ContentTypes.STATIC}`]: 2000,
          [`${ContentTypes.STATIC_MEDIA}`]: 1125,
        },
      },
      [`${OperationTypes.WRITE}`]: {
        total: 1500,
        byContentType: {
          [`${ContentTypes.DYNAMIC}`]: 1000,
          [`${ContentTypes.STATIC_MEDIA}`]: 500,
        },
      },
    },
  },
  processingCapacity: {
    total: 4875,
    byOperationType: {
      [`${OperationTypes.READ}`]: {
        total: 3375,
        byContentType: {
          [`${ContentTypes.DYNAMIC}`]: 250,
          [`${ContentTypes.STATIC}`]: 2000,
          [`${ContentTypes.STATIC_MEDIA}`]: 1125,
        },
      },
      [`${OperationTypes.WRITE}`]: {
        total: 1500,
        byContentType: {
          [`${ContentTypes.DYNAMIC}`]: 1000,
          [`${ContentTypes.STATIC_MEDIA}`]: 500,
        },
      },
    },
  },
  purchasePrice: 150,
  sellPrice: 75,
  costPerCycle: 1.2,
  outputConnectorLimits: {},
};
